import React, { useState, useEffect } from 'react'
import { getCookie } from 'helper/cookie'
import SprintTaskFlow from './SprintTaskFlow'
import AddTask from './AddTask'
import Flow from './Flow'
import Form from 'antd/lib/form/Form'
import { Helmet } from 'react-helmet'
import { Modal } from 'antd'
import { CloseCircleOutlined } from '@ant-design/icons'
import { isMobile } from 'react-device-detect'

const initialState = {
  switchTaskFlowComponents: 'sprinttaskflow',
  syncFuntion: '',
}

const TaskFlow = (props) => {
  const {
    swithCaseFunction,
    canNotEditProject,
    idEditPRJ,
    statusProject,
    sendmailStatus,
    canKPIFinance,
    memberRole,
    canSprintTaskFlow,
    setCheckChangeFlow,
    checkChangeFlow,
    checkCanEditProjectByStatus,
    checkPlandateTaskSubTask,
    setWordErrFlow,
    checkStatusWaiting,
    setVisibleSaveDraft,
    form,
    checkBtn,
    fullyCheckComplete,
    setFullyCheckComplete,
  } = props
  const token = getCookie('access_token_admin')
  const [switchTaskFlowComponents, setSwitchTaskFlowComponents] = useState(
    initialState.switchTaskFlowComponents,
  )
  const swithCaseTaskFLowFunction = (type) => {
    setSwitchTaskFlowComponents(type)
  }
  const [idChart, setIdChart] = useState(1)
  const [code, setCode] = useState('')
  const [statusTask, setStatusTask] = useState()
  const [rolee, setrolee] = useState()
  const [checkDecision, setCheckDecision] = useState(false)
  const checkMobileView = isMobile
  let checkDecision2 = false
  if (checkDecision == 'flow-rhombus') {
    checkDecision2 = true
  } else {
    checkDecision2 = false
  }

  const renderComponents = (type) => {
    switch (switchTaskFlowComponents) {
      case 'addtask':
        return (
          <AddTask
            memberRole={memberRole}
            canKPIFinance={canKPIFinance}
            canSprintTaskFlow={canSprintTaskFlow}
            idEditPRJ={idEditPRJ}
            rolee={rolee}
            canNotEditProject={canNotEditProject}
            setrolee={setrolee}
            swithCaseTaskFLowFunction={swithCaseTaskFLowFunction}
            funcsetIdChart={idChart}
            code={code}
            statusProject={statusProject}
            sendmailStatus={sendmailStatus}
            checkDecision={checkDecision2}
            checkCanEditProjectByStatus={checkCanEditProjectByStatus}
            checkPlandateTaskSubTask={checkPlandateTaskSubTask}
            checkStatusWaiting={checkStatusWaiting}
            checkChangeFlow={checkChangeFlow}
            setCheckChangeFlow={setCheckChangeFlow}
            fullyCheckComplete={fullyCheckComplete}
          />
        )
      case 'sprintflow':
        return <SprintTaskFlow swithCaseTaskFLowFunction={swithCaseTaskFLowFunction} />
      default:
        return (
          <Flow
            canSprintTaskFlow={canSprintTaskFlow}
            idEditPRJ={idEditPRJ}
            role={canNotEditProject}
            swithCaseTaskFLowFunction={swithCaseTaskFLowFunction}
            swithCaseFunction={swithCaseFunction}
            funcsetIdChart={setIdChart}
            setCode={setCode}
            statusProject={statusProject}
            setStatusTask={setStatusTask}
            setrolee={setrolee}
            setCheckDecision={setCheckDecision}
            setCheckChangeFlow={setCheckChangeFlow}
            checkChangeFlow={checkChangeFlow}
            checkPlandateTaskSubTask={checkPlandateTaskSubTask}
            setWordErrFlow={setWordErrFlow}
            setFullyCheckCompleteInCommon={setFullyCheckComplete}
          />
        )
    }
  }

  useEffect(() => {
    renderComponents()
  }, [switchTaskFlowComponents, statusTask])

  const onFinish = () => {
    if (checkBtn == 'save') {
      setVisibleSaveDraft(true)
    }
  }
  const [modalAlert, setModalAlert] = useState(false)
  useEffect(() => {
    if (checkMobileView == true) {
      setModalAlert(true)
    }
  }, [checkMobileView])

  return (
    <div>
      <Helmet>
        <title>Create Project | Sprint(Task)Flow</title>
      </Helmet>
      <Form form={form} onFinish={onFinish}>
      </Form>

      <Modal
        className="ModalStatusOption"
        visible={modalAlert}
        onOk={() => setModalAlert(false)}
        onCancel={() => setModalAlert(false)}
        okText="Confirm"
        cancelButtonProps={{ hidden: true }}
      >
        <CloseCircleOutlined className='CloseCircleOutlined ' />
        <h2>AXONS Project does not support</h2>
        <h4>
          The AXONS Project does not support creating or editing sprint tasks via mobile
          phones, tablets and iPad.
        </h4>
      </Modal>
      <div>{renderComponents()}</div>
    </div>
  )
}

export default TaskFlow
